import React, { useState } from 'react';
import { toast } from 'react-toastify';

import services from 'api/services';
import { useFreecodeContextData } from 'hooks/useContext';
import ConfirmModal from 'components/Modals/confirmModal';
import { ObjectException } from 'global/errors';

const { FreecodeCreatorService } = services;

export default function GraphicsDeleteModal({ graphicsIndex, closeModal }) {
  const {
    setTestImpl,
    testImpl: { _id, test, graphics },
  } = useFreecodeContextData();

  const [loading, setLoading] = useState(false);

  const handleOnConfirm = () => {
    if (loading) return toast.error('Already loading');
    setLoading(true);

    const doConfirm = async () => {
      try {
        let update = [...graphics];
        update.splice(graphicsIndex, 1);

        let response = await FreecodeCreatorService.saveGraphics(test, _id, update);
        if (response.error)
          throw new ObjectException(response.error?.message || 'Graphics update failed', 'response error');
        if (!response.graphics) throw new ObjectException('Response missing graphics', 'response error');

        setTestImpl((oldTestImpl) => ({ ...oldTestImpl, graphics: response.graphics }));
        toast.success('Image deleted!');
        closeModal();
      } catch (e) {
        toast.error(typeof e === 'string' ? e : e?.message || 'Could not upload graphics');
      } finally {
        setLoading(false);
      }
    };
    doConfirm();
  };

  return (
    <ConfirmModal
      title="Delete Image"
      text="Are you sure you want to delete this image?"
      onConfirm={() => handleOnConfirm()}
      onCancel={() => closeModal()}
      loading={loading}
    />
  );
}
